<template>
  <div class="advisors">
    <TextPage>
      <div class="copy-header">
        <div class="inner-copy">
          <p class="knuvu-title">Advisors</p>
          <p>We pull in Domain Experts to advise us on client or segment specific issues. We have a network of approximately 100+ technical and functional business leaders with well-known bodies of work that we will call in to advise.</p>
        </div>
      </div>
    </TextPage>
  </div>
</template>

<script>
import TextPage from "@/components/global/text-page.vue";
export default {
  name: "Advisors",
  title: "Advisors - Knuvu",
  components: {
    TextPage,
  },
};
</script>